import { useContext } from 'react'

import Link from 'tools/Link'
import { WaitThen } from 'tools/Loading'
import { MaxViewPage } from 'tools/Uniform'

import SignForm from 'app/Auth/SignOn/Form'
import { isAuthZ } from 'app/Auth/lib'
import GlobalContext from 'reducer/global'

const UNAUTHED_CHILDREN = (
  <div className="flex flex-column items-center mt5">
    <h1 className="mb3">Sorry, you are not authorized for this feature</h1>
  </div>
)

export function Authorized({
  children,
  action,
  actions,
  role,
  roles,
  unauthedChildren = UNAUTHED_CHILDREN
}) {
  const [{ user }] = useContext(GlobalContext)

  if (isAuthZ(user, { action, actions, role, roles })) {
    return children
  }
  return unauthedChildren
}

export function SignonAuthed(props) {
  return (
    <SignonRequired>
      <Authorized {...props} />
    </SignonRequired>
  )
}

export function SignonRequired({ children, what }) {
  const [{ user }] = useContext(GlobalContext)

  if (user?.isIdentified && user?.verified) return children

  what ??= 'continue'
  if (user.isIdentified) {
    return (
      <WaitThen>
        <MaxViewPage>
          <div className="pa5 tc dib">
            <h1>You’re Almost There!</h1>
            <p className="f4">
              Please verify your email address—check your inbox for the
              verification email
            </p>
            <p />
            Not seeing it?{' '}
            <Link to="/help/verify">Learn More about Email Verification</Link>
          </div>
        </MaxViewPage>
      </WaitThen>
    )
  }

  return (
    <WaitThen>
      <SignForm signup={true}>
        <p className="f4">To {what}, please sign in to your account.</p>
      </SignForm>
    </WaitThen>
  )
}
